import { ClipboardEvent, useCallback } from 'react';

export const useClipboardPasting = (disabled: boolean) => {
  const disabledPasteHandler = useCallback(
    (event: ClipboardEvent) => {
      if (!disabled) return true;

      event.preventDefault();
      const str = event.clipboardData.getData('Text');
      str.replace(/[+-.]/g, '');
      return false;
    },
    [disabled],
  );

  return { disabledPasteHandler };
};
